"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteInvocationInvoker = void 0;
const cq_core_1 = require("@leavy/cq-core");
const errors_1 = require("./errors");
/**
 * Invoke a given invocation throught RPC protocol
 */
class RemoteInvocationInvoker {
    constructor(protocol, requestBuilder, ambientValueInjector = new cq_core_1.DefaultAmbientValueInjector()) {
        this.protocol = protocol;
        this.requestBuilder = requestBuilder;
        this.ambientValueInjector = ambientValueInjector;
    }
    /**
     * Invoke remote procedure
     * @param invocationClass
     * @param invocationData
     * @param invokingContext
     */
    async invokeResult(invocationClass, invocationData, invokingContext) {
        // Inject ambient values if presents
        if (invokingContext === null || invokingContext === void 0 ? void 0 : invokingContext.ambientValues) {
            this.ambientValueInjector.inject(invokingContext, invocationClass, invocationData);
        }
        // send request
        const request = await this.requestBuilder.from(invocationClass, invocationData, this.protocol);
        try {
            return await request.send(invokingContext);
        }
        catch (e) {
            return {
                type: cq_core_1.InvocationResultType.RequestError,
                error: e,
            };
        }
    }
    /**
     * Execute method is a higher API method for invoking remote invocations that will:
     * - Raise an exception on request or execution failures
     * - Raise an exception if the given invocation is not valid
     * - Return the ExecutionResult instead of the InvocationResult
     */
    async invoke(invocationOrType, dataOrContext, context) {
        let invocationType;
        let invocationData;
        if (typeof invocationOrType === "function") {
            invocationType = invocationOrType;
            invocationData = dataOrContext;
        }
        else {
            invocationType = invocationOrType.constructor;
            invocationData = invocationOrType;
            context = dataOrContext;
        }
        const result = await this.invokeResult(invocationType, invocationData, context);
        if (result.type === cq_core_1.InvocationResultType.Error || result.type === cq_core_1.InvocationResultType.RequestError) {
            throw result.error;
        }
        if (result.type === cq_core_1.InvocationResultType.Invalid) {
            throw new errors_1.InvocationValidationError(result.validationResult, "Remote invocation validation failed");
        }
        if (result.type === cq_core_1.InvocationResultType.NotAuthorized) {
            throw new errors_1.UnauthorizedError("Remote invocation authorization failed");
        }
        return result.result;
    }
}
exports.RemoteInvocationInvoker = RemoteInvocationInvoker;
//# sourceMappingURL=RemoteInvocationInvoker.js.map